import { useCallback, useMemo, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { selectTradeboxState } from "context/SyntheticsStateContext/selectors/tradeboxSelectors";
import { useSelector } from "context/SyntheticsStateContext/utils";
import { TradeType, TradeTypeV2 } from "domain/synthetics/trade";
import { useLocalizedMap } from "lib/i18n";

import { SwipeTabs } from "components/SwipeTabs/SwipeTabs";
import Tabs from "components/Tabs/Tabs";

import { mobileTradeTypeClassNames, tradeTypeClassNames, tradeTypeIcons, tradeTypeLabels } from "./tradeboxConstants";

const OPTIONS = Object.values(TradeType);

export function TradeBoxHeaderTabs({ isInCurtain }: { isInCurtain?: boolean }) {
  const localizedTradeTypeLabels = useLocalizedMap(tradeTypeLabels);
  const history = useHistory();
  const location = useLocation();
  // console.log("%c Line:20 🍬 location", "color:#2eafb0", location);

  const { setTradeType: onSelectTradeType, tradeType } = useSelector(selectTradeboxState);
  const onTradeTypeChange = useCallback(
    (type: TradeType) => {
      onSelectTradeType(type);
      if (tradeType !== type) {
        history.push(`/trade/${type.toLowerCase()}`);
      }
    },
    [history, onSelectTradeType, tradeType]
  );

  const [pageState, setPageState] = useState("home");

  useEffect(() => {
    if (location?.pathname == "/perpx-swap") {
      onSelectTradeType(TradeType.Swap);
      setPageState("perpx-swap");
    } else if (location?.pathname == "/trade") {
      onSelectTradeType(TradeType.Long);
      setPageState("home");
    }
  }, [location]);

  // if (location?.pathname == "/perpx-swap") {
  //   onSelectTradeType(TradeType.Swap);
  //   setPageState("perpx-swap");
  // } else {
  //   setTimeout(() => {
  //     onSelectTradeType(TradeType.Long);
  //     setPageState("home");
  //   }, 500);
  // }
  //   }, [location]);

  //   useEffect(() => {
  //     if (location?.pathname == "/v1" || location?.pathname == "/trade" || location?.pathname == "/trade/long") {
  //       onSelectTradeType(TradeType.Long);
  //       setPageState("home");
  //     }
  //   }, []);

  const tabsOptions = useMemo(() => {
    return Object.values(TradeTypeV2).map((type) => ({
      value: type,
      label: localizedTradeTypeLabels[type],
      className: tradeTypeClassNames[type],
      icon: tradeTypeIcons[type],
    }));
  }, [localizedTradeTypeLabels]);

  if (!isInCurtain) {
    return (
      <>
        {pageState == "perpx-swap" ? (
          <></>
        ) : (
          <Tabs
            options={tabsOptions}
            selectedValue={tradeType}
            onChange={onTradeTypeChange}
            size="l"
            qa="trade-direction"
          />
        )}
      </>
    );
  }

  return (
    <>
      {pageState == "perpx-swap" ? (
        <></>
      ) : (
        <SwipeTabs
          icons={tradeTypeIcons}
          options={OPTIONS}
          optionLabels={localizedTradeTypeLabels}
          option={tradeType}
          onChange={onTradeTypeChange}
          optionClassnames={mobileTradeTypeClassNames}
          qa="trade-direction"
        />
      )}
    </>
  );
}
